import { registerAmriModule } from '../amri';
import { initCarousel } from './carousel';
import { initAccordion } from './accordion';

/**
 * `Amri.Home.init()` — boots all home-page interactivity. Idempotent: safe to
 * call multiple times (each `init*` function only attaches listeners once per
 * element by using fresh references). Matches the legacy entry-point shape:
 *
 *   Amri.Home.init({ urls: {...}, showLogin: false, ... });
 *
 * Options parameter is preserved for forward compatibility (Phase 3.8.2 will
 * wire login redirect; Phase 3.8.3 will wire form-submission URLs). For 3.8
 * the options are ignored — carousel + accordion need no config.
 */
export interface HomeInitOptions {
    urls?: Record<string, string>;
    showLogin?: boolean;
    loginRedirectUrl?: string | null;
}

const Home = {
    init(_options?: HomeInitOptions): void {
        // _options reserved for Phase 3.8.2+; intentionally unused in 3.8.
        initCarousel();
        initAccordion();
    },
};

registerAmriModule('Home', Home);
